// Moved to components/Table/DataTable — nothing here was reservations-specific.
//
// The formatter this tab needs still lives in ProReservationsContainer, which passes it
// as `formatValue` and also uses it for the CSV export. The pinned header the copy here
// hard-coded is now the shared table's `stickyHeader` prop, set by the container.
export { default } from '../../Table/DataTable';
